







































import { Component, Prop, Vue, Emit } from 'nuxt-property-decorator'

@Component
class NewPagination extends Vue {
  @Prop({
    type: Object, default: () => {
      return {}
    }, required: false,
  })
  data!: any

  @Prop({ type: String, default: '', required: false })
  paginationClass?: string

  get array() {
    return this.data?.pageCursors?.around?.map(p => p.page).sort((n1,n2) => n1 - n2);
  }

  get currentPage() {
    return this.data.pageInfo
  }

  @Emit()
  changePage(page) {
    const targetPage = this.data?.pageCursors.around.find(p => p.page == page)
    if (!targetPage) {
      const direction = page - this.currentPage.pageNumber
      return direction < 0 ? { before: this.currentPage.startCursor } : { before: this.currentPage.endCursor }
    }
    return { after: targetPage.cursor }
  }
}

export default NewPagination
